import { ModalPositionType } from '@/context/modal-context/types'
import cx from 'classnames'
import s from './modal-pane.module.scss'

type Props = {
  children?: React.ReactNode
  position: ModalPositionType
}

export const ModalPane = (props: Props) => {
  const { children, position } = props

  return (
    <>
      <div className={cx(s.container, s[position])}>{children}</div>
    </>
  )
}
